<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-text`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.0467 17.242H5.95263V16.6426C6.30734 16.5321 6.66754 16.4354 7.03217 16.3529C7.39585 16.2693 7.78773 16.2014 8.20841 16.1451V3.83376H5.1388L3.85371 6.79348H2.95667V2.75804H17.0433V6.79405H16.1354L14.8612 3.83432H11.8159V16.1462C12.2359 16.2158 12.629 16.2844 12.9915 16.354C13.3558 16.4225 13.7067 16.5183 14.0467 16.6437L14.0467 17.242Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillText',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
